import React                   from 'react';
import { Form }                from 'antd';
import { Col }                 from 'antd';
import Row                     from 'components/App/Row';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import RichTextEditor          from 'components/App/RichTextEditor';
import FormItemDragger         from 'components/App/FormItemDragger';
import MessageMediaModel       from 'models/MessageMediaModel';
import handleFormError         from 'utils/handleFormError';
import DemandModel             from 'models/DemandModel';
import DemandMessageModel      from 'models/DemandMessageModel';
import type { RefObject }      from 'react';
import type { FormInstance }   from 'antd';
import { AppFormComponent }    from 'components/App/AppForm';
import MessageModel            from 'models/MessageModel';

interface DemandMessageFormProps {
  demand: DemandModel;
  message: MessageModel;
  model: DemandMessageModel;
  onSuccess?: (demandMessage: DemandMessageModel) => void;
}

class DemandMessageForm extends AppFormComponent<DemandMessageFormProps> {
  public formRef: RefObject<FormInstance> = React.createRef();

  public componentDidMount() {
    const { message } = this.props;

    this.formRef.current?.setFieldsValue({
      attachments: [],
      content: message.get('content'),
    });
  }

  public render() {
    return (
      <Form ref={this.formRef}>
        <Row>
          <Col span={24}>
            <Form.Item
              // help={getFieldError('content') || ''}
              // validateStatus={getFieldError('content') ? 'error' : ''}
              label={<FormattedMessageWrapper id="Message" />}
              labelCol={{ span: 24 }}
              name="content"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Contenu manquant" />,
                  required: true,
                },
              ]}
            >
              <RichTextEditor style={{ height: 150, marginBottom: 32 }} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <FormItemDragger name="attachments" />
          </Col>
        </Row>
      </Form>
    );
  }

  public submit = async () => {
    const { demand, message, model, onSuccess } = this.props;

    const values = await this.formRef.current?.validateFields();

    try {
      const attachments = [];

      for (let i = 0; i < values.attachments.length; i += 1) {
        const messageMedia = await this.uploadMessageMedia(values.attachments[i].originFileObj);
        attachments.push(messageMedia.data['@id']);
      }

      await message.patch({
        attachments,
        content: values.content,
      });

      await model.patch({
        demand: demand.get('@id'),
        message: message.get('@id'),
      });

      if (onSuccess) {
        onSuccess(model);
      }
    } catch (error) {
      handleFormError(error, this.formRef.current);
    }
  };

  private uploadMessageMedia = async (file: any) => {
    const messageMediaModel = new MessageMediaModel();

    messageMediaModel.set({
      enabled: true,
      file,
    });

    await messageMediaModel.save();

    return messageMediaModel;
  };
}

export default DemandMessageForm;
